import OrderHistoryMenu from './OrderHistoryMenu';

interface IOrderHistory {
  previous_month_orders_exists: boolean;
  next_month_orders_exists: boolean;
  period: Date;
  orders: OrderHistoryMenu[];
}

class OrderHistory implements IOrderHistory {
  previous_month_orders_exists: boolean;
  next_month_orders_exists: boolean;
  period: Date;
  orders: OrderHistoryMenu[];

  constructor(attributes?: IOrderHistory) {
    Object.assign(this, attributes);

    this.orders = this.orders.map(
      (item) => new OrderHistoryMenu(item),
    ) ?? [];
  }
}

export { IOrderHistory };
export default OrderHistory;
